"use client";

import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { Arrow } from "@faire/web/slate/icons/foundation/Arrow";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { Link } from "@faire/web/ui/LinkAnchor";
import React from "react";

// eslint-disable-next-line import/no-unassigned-import
import "./native-styles.css";

export interface CTATileData {
  text: React.ReactNode;
  linkTo: string;
  onClick?: () => void;
  alwaysVisible?: boolean;
}

export const maybeAddCTATile = <T,>(
  arr: ReadonlyArray<T>,
  data: CTATileData | undefined,
  itemsPerSlide: number
) => {
  if (shouldAddCTATile(arr, data, itemsPerSlide) && isNotUndefined(data)) {
    return [...arr, <CTATile key="cta-tile" data={data} />];
  } else {
    return arr;
  }
};

export const shouldAddCTATile = <T,>(
  arr: ReadonlyArray<T>,
  data: CTATileData | undefined,
  itemsPerSlide: number
) => {
  return (
    isNotUndefined(data) && (arr.length > itemsPerSlide || data.alwaysVisible)
  );
};

export const CTATile: React.FC<{ data: CTATileData }> = ({ data }) => {
  return (
    <Link
      className="f_c_cta_tile_wrapper"
      to={data.linkTo}
      onClick={data.onClick}
      data-test-id="cta-tile-wrapper"
    >
      <Row
        className="f_c_cta_tile_icon_wrapper"
        align="center"
        justify="center"
      >
        <Arrow direction="right" fontSize="32px" />
      </Row>
      <Spacer height="2x" />
      <Typography variant="paragraphSansMedium" align="center">
        {data.text}
      </Typography>
    </Link>
  );
};
